import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router } from 'react-router-dom';
import Configurator from 'bookingbug-configurator-js';
import { Provider } from 'react-redux';
import App from './App';
import store from './store';
import * as serviceWorker from './serviceWorker';
// import '../node_modules/@fortawesome/fontawesome-free/js/all';
// import '../node_modules/@fortawesome/fontawesome-free/css/all.css';
import 'moment-timezone';
import './index.scss';

import { ConfiguratorProvider } from './hooks/Configurator';
import { bootstrapAnalytics } from './helpers/analytics/setup/analytics.service.setup';


const urlParams = new URLSearchParams(window.location.search);
const client = urlParams.get('client');
const product = urlParams.get('product') || 'kiosk';
const environment = urlParams.get('environment') || 'production';

window.FontAwesomeConfig = {
  searchPseudoElements: true,
};

if (!client) {
  throw new Error('You must specify a client');
}

try {
  Configurator.getCustomConfig({
    client,
    product,
    environment,
  }).then(() => {
    bootstrapAnalytics();
    // eslint-disable-next-line
    require('./branding/branding');
    const app = (
      <ConfiguratorProvider>
        <Provider store={store}>
          <Router>
            <App />
          </Router>
        </Provider>
      </ConfiguratorProvider>
    );
    ReactDOM.render(app, document.getElementById('root'));
    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://bit.ly/CRA-PWA
    serviceWorker.unregister();
  });
} catch (e) {
  console.log(e);
}
